import { useEffect, useState } from "react";
import { navItems } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="h-16 md:h-20 flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer shrink-0">
            <span className="w-9 h-9 rounded-md flex items-center justify-center bg-primary-500 text-background-50 font-heading text-lg font-bold">
              瓜
            </span>
            <span
              className={`font-heading text-lg md:text-xl font-bold tracking-tight whitespace-nowrap transition-colors ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              黑料网吃瓜
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-0.5">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`text-sm px-3 py-2 rounded-md cursor-pointer transition-colors whitespace-nowrap ${
                  solid
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                    : "text-background-100/90 hover:text-background-50 hover:bg-background-50/10"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href="#flash"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-flashlight-fill text-[15px]"></i>
            今日速报
          </a>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
              solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-5 pt-2">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-sm text-foreground-800 border-b border-background-100 cursor-pointer hover:text-primary-600 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#flash"
            onClick={() => setMenuOpen(false)}
            className="mt-4 flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-flashlight-fill text-[15px]"></i>
            今日速报
          </a>
        </div>
      )}
    </header>
  );
}